import { loginUrl, logoutUrl, rootUrl } from '@utils/UrlBuilder';

const restrictedRedirectUrls = ['', rootUrl(), loginUrl(), logoutUrl()];

export default restrictedRedirectUrls;
